import { Movie } from '../types';

export const generateSlug = (movie: Movie | { id: string | number, title?: string, name?: string }) => {
  const title = movie.title || (movie as any).name || 'watch';
  const cleanTitle = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');
  return `/${cleanTitle}-${movie.id}`;
};
